module.exports = __webpack_public_path__ + "assets/img/icon-logo.28cf068a.png";